import PropTypes from "prop-types";
import React from "react";

import { PROVIDER_DETAIL_STYLES } from "../../styles";

export default function ProviderDetailSectionCard({ children, className = "" }) {
  return (
    <div
      className={`rounded-[16px] p-5 md:col-span-2 ${className}`.trim()}
      style={PROVIDER_DETAIL_STYLES.sectionCard}
    >
      {children}
    </div>
  );
}

ProviderDetailSectionCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
